import { useEffect, useState } from 'react';
import socket_sv from 'src/utils/service/SocketSv';
const useCheckConnectionToServer = () => {
    const [countDisconect, setCountDisconect] = useState(0);

    useEffect(() => {
        const checkHeartBeat = () => {
            const controller = new AbortController();
            const timeoutId = setTimeout(() => {
                controller.abort(); // Hủy request nếu quá 3 giây
            }, 3000);
            const url = socket_sv.server_domain + 'api/check_connection';
            fetch(url, { signal: controller.signal, cache: 'no-store' })
                .then((res) => {
                    if (!res.ok) throw new Error('Bad response');
                    if (countDisconect !== 0) {
                        setCountDisconect(0);
                    }
                })
                .catch((err) => {
                    console.log('connection server error: ' + err);
                    if (countDisconect < 3) {
                        setCountDisconect((prev) => prev + 1);
                    }
                })
                .finally(() => {
                    clearTimeout(timeoutId);
                });
        };
        const intervalId = setInterval(checkHeartBeat, 10000);

        return () => clearInterval(intervalId);
    }, [countDisconect]);

    return {
        countDisconect,
        setCountDisconect,
    };
};

export default useCheckConnectionToServer;
